<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除 </el-button>
      </div>
      <el-row :gutter="15">
        <!-- 班级树 -->
        <el-col :md="5" style="margin-bottom: 15px">
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="deptData"
              :props="{ label: 'name' }"
              :expand-on-click-node="false"
              node-key="id"
              :default-expand-all="true"
              @node-click="chooseClass"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="19" style="margin-bottom: 15px">
          <!-- 成绩表格数据 -->
          <ele-data-table
            ref="table"
            :initLoad="false"
            :config="table"
            :row-key="getRowKey"
            :choose.sync="choose"
            height="calc(100vh - 261px)"
            highlight-current-row
          >
            <template #default="{ index }">
              <el-table-column type="selection" width="45" align="center" fixed="left" :reserve-selection="true" />
              <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
              <el-table-column prop="examName" label="考试名称" sortable="custom" show-overflow-tooltip min-width="110" />
              <el-table-column prop="teacherName" label="教师姓名" sortable="custom" show-overflow-tooltip min-width="110" />
              <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip min-width="110" />
              <el-table-column label="操作" width="230px" align="center" :resizable="false">
                <template #default="{ row }">
                  <el-link v-if="table.where.id" @click="viewScroe(row)" icon="el-icon-edit" type="primary" :underline="false">查看成绩</el-link>
                  <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
                  <el-popconfirm title="确定要删除此次成绩吗？" @onConfirm="remove(row)" class="ele-action">
                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </template>
          </ele-data-table>
          <!-- 编辑弹窗 -->
          <el-dialog
            :title="editForm.id ? '修改考试' : '导入考试成绩'"
            :visible.sync="showEdit"
            width="500px"
            @closed="editForm = {}"
            :destroy-on-close="true"
            custom-class="ele-dialog-form"
            :lock-scroll="false"
          >
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
              <el-row :gutter="15">
                <el-col>
                  <el-form-item label="考试名称:" prop="examName">
                    <el-input v-model="editForm.examName" placeholder="请输入考试名称" clearable />
                  </el-form-item>
                  <el-form-item label="成绩上传:" prop="file">
                    <el-upload
                      action=""
                      :before-upload="beforeUpload"
                      :on-change="handleUpload"
                      :file-list="fileList"
                      class="ele-block"
                      drag
                      accept=".xls,.xlsx"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text"> 将文件拖到此处，或 <em>点击上传</em> </div>
                      <div class="el-upload__tip ele-text-center" slot="tip">
                        只能上传xls、xlsx文件，
                        <el-link
                          type="primary"
                          :underline="false"
                          href="https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1624071096526/新平台成绩录入.xls"
                          download
                          style="vertical-align: baseline"
                          >下载模板
                        </el-link>
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer">
              <el-button @click="showEdit = false">取消</el-button>
              <el-button type="primary" @click="save(editForm.id)">保存</el-button>
            </div>
          </el-dialog>
          <!--查看成绩弹窗-->
          <el-dialog title="查看成绩" :visible.sync="showCore" width="70%" @close="(coreData = []), (subjects = [])">
            <div class="ele-table-tool ele-table-tool-default">
              <el-button @click="sendScore" type="primary" icon="el-icon-s-promotion" class="ele-btn-icon" size="small">发送成绩</el-button>
            </div>
            <ele-data-table
              ref="coreTable"
              :config="coreTable"
              :data="coreData"
              :row-key="getRowKeyR"
              :choose.sync="chooseScore"
              height="calc(90vh - 261px)"
              highlight-current-row
              v-loading="loadingTable"
              element-loading-text="获取成绩中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
            >
              <template>
                <el-table-column type="selection" width="45" align="center" fixed="left" :reserve-selection="true" />
                <el-table-column
                  v-for="item in subjects"
                  :key="item.id"
                  :prop="item"
                  :label="item"
                  sortable="custom"
                  show-overflow-tooltip
                  align="center"
                />
              </template>
            </ele-data-table>
          </el-dialog>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import {
    alterStudentExamExcel,
    deleteExamByIds,
    importStudentExamExcel,
    examInfoById,
    examSubInfoById,
    examSendSMS,
    finiteDataTree,
  } from '@/config/api';

  export default {
    name: 'Score',
    data() {
      return {
        loading: true, // 加载状态
        deptData: [], // 列表数据
        table: {
          // 成绩表格配置
          url: '/school/exam/examListByClassId',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 导入成绩表格选中数据
        showEdit: false, // 导入成绩弹窗
        editForm: {},
        editRules: {
          // 表单验证规则
          examName: [{ required: true, message: '请输入考试名称', trigger: 'blur' }],
        },
        getRowKey(row) {
          return row.id;
        },
        uploadLoading: false,
        fileList: [],
        showCore: false, //查看成绩弹窗
        coreTable: {
          //成绩详情表格数据
          page: false,
        },
        coreData: [], //成绩数据
        subjects: [], //科目
        getRowKeyR(row) {
          return row.id;
        },
        chooseScore: [], //选中的成绩
        classId: null,
        currentClass: null,
        loadingTable: false,
      };
    },

    mounted() {
      this.query();
    },
    methods: {
      // 添加导入成绩
      add() {
        if (this.currentClass.orgType === 4) {
          this.showEdit = true;
        } else {
          this.$message.info('请选择班级');
        }
      },
      /* 显示编辑 */
      edit(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      //展示学校班级树
      query() {
        this.loading = true;
        finiteDataTree().then((res) => {
          this.loading = false;
          if (res.data.resCode == 200) {
            this.deptData = res.data.data;
            // setTimeout(() => {
            //   this.chooseClass(this.deptData[0].children[0].children[0].children[0]);
            // }, 100);
          } else {
            this.$message.error(res.data.resMsg || '获取数据失败');
          }
        });
      },
      //选择数据
      chooseClass(row) {
        this.currentClass = row;
        if (row.orgType === 4) {
          this.$refs.orgTree.setCurrentKey(row.id);
          this.table.where.id = row.id.slice(1);
          this.classId = row.id.slice(1);
          this.$refs.table.reload();
        }
      },
      //成绩导入之前
      beforeUpload(file) {
        this.editForm.file = file;
        return false;
      },
      // 监听导入变化
      handleUpload(file, fileList) {
        this.fileList = fileList.slice(-1);
        return false;
      },
      //保存编辑
      save(scoreId) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (scoreId == undefined) {
              //添加成绩
              if (this.editForm.file) {
                formData.append('classId', this.classId);
                importStudentExamExcel(formData).then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({
                      type: 'success',
                      message: res.data.resMsg,
                      duration: 3000,
                      showClose: true,
                      customClass: 'messageHeight',
                      dangerouslyUseHTMLString: true,
                    });
                    this.$refs.table.reload();
                    this.fileList = [];
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                });
              } else {
                loading.close();
                this.$message.error('请选择成绩文件');
              }
            } else {
              //编辑名称
              alterStudentExamExcel(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                  this.fileList = [];
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 删除
      remove(row) {
        if (!row) {
          // 批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          let ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的成绩记录吗?', '提示', {
            type: 'warning',
          }).then(() => {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            formData.append('ids', ids);
            deleteExamByIds(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          });
        } else {
          // 单个删除
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('ids', row.id);
          deleteExamByIds(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      //查看成绩
      viewScroe(row) {
        // const loading = this.$loading({lock: true});
        this.loadingTable = true;
        let data = {
          classId: this.table.where.id,
          id: row.id,
        };
        examSubInfoById(data).then((res) => {
          if (res.data.resCode == 200) {
            this.subjects = res.data.data;
            examInfoById(data).then((e) => {
              this.loadingTable = false;
              if (e.data.resCode == 200) {
                this.coreData = e.data.data;
                this.showCore = true;
              }
            });
          }
        });
      },
      //发送成绩
      sendScore() {
        if (this.chooseScore.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.chooseScore.map((d) => d.id);
        this.$confirm('确定要发送选中的成绩记录吗?', '提示', {
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('ids', ids);
          examSendSMS(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.coreTable.clearSelection();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
    },
  };
</script>

<style>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(115vh - 262px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
  .messageHeight {
    max-height: 600px;
    overflow-y: scroll;
    padding: 10px;
  }
</style>
